import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AuthPopupService, AuthService } from './../../../auth/services';
import { Client } from './../../../domain/models';
import { ClientService } from './../../../domain/services/client.service';
import { Program } from './../../models';
import { ProgramService } from './../../services/program.service';

@Component({
    selector: 'app-program-card-collection',
    templateUrl: './program-card-collection.component.html',
    styleUrls: ['./program-card-collection.component.scss'],
    standalone: false
})
export class ProgramCardCollectionComponent implements OnInit {
    client: Client | undefined;
    programs: Program[] | undefined;
    selectedPrograms: Program[] = [];
    selectedProgramIds: number[] = [];

    constructor(
        private programService: ProgramService,
        private router: Router,
        private readonly _authPopup: AuthPopupService,
        private readonly _auth: AuthService,
        private readonly _client: ClientService
    ) {}

    ngOnInit() {
        this.programService.getPrograms().subscribe((res) => {
            this.programs = res;

            this.programs.forEach((program: Program) => {
                // prepend API URL
                if (program.logoPath)
                    program.logoPath = `${environment.apiUrl}${program?.logoPath}`;
            });
        });

        this._client.latest.subscribe((client) => {
            if (!client) return;
            this.client = client;
        });
    }

    updateSelectedPrograms(program: Program) {
        let programId: number = program.programId ?? 0;

        if (programId !== 0) {
            if (this.selectedProgramIds.indexOf(programId) == -1) {
                this.selectedPrograms.push(program);
                this.selectedProgramIds.push(programId);
            } else {
                this.selectedPrograms.splice(
                    this.selectedProgramIds.indexOf(programId),
                    1
                );
                this.selectedProgramIds.splice(
                    this.selectedProgramIds.indexOf(programId),
                    1
                );
            }
        }
    }

    searchProviders() {
        // store program Ids in sessionStorage
        sessionStorage.setItem(
            'selectedProgramIds',
            this.selectedProgramIds.toString()
        );

        // navigate to providers
        this.router.navigateByUrl(`${runtimeConfig.clientCode}/provider`);
    }

    navigation(route: string) {
        this.router.navigateByUrl(`${runtimeConfig.clientCode}/${route}`);
    }

    startApplication(): void {
        //Store the waitlist IDs in a local variable to be checked later
        sessionStorage.setItem(
            'applicationProviderIds',
            this.client?.waitlistProviderIds?.toString() || ''
        );

        //Store the waitlist IDs in a local variable to be checked later
        sessionStorage.setItem(
            'waitlistProviderIds',
            this.client?.waitlistProviderIds?.toString() || ''
        );

        //Signup and/or start the application
        if (this._auth.isSignedIn)
            this.router.navigateByUrl(`${this.client?.clientCode}/application`);
        else {
            this._authPopup.showAccountCreation();
        }
    }
}
